var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPosaPavimenti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    id: "svg20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs20"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 32.53,
    y: 10.16,
    width: 13.44,
    height: 4.03,
    transform: "translate(20.11 -24.19) rotate(45)",
    id: "rect1",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 32.53,
    y: 15.86,
    width: 13.44,
    height: 4.03,
    transform: "translate(24.14 -22.52) rotate(45)",
    id: "rect2",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 32.53,
    y: 21.56,
    width: 13.44,
    height: 4.03,
    transform: "translate(28.17 -20.85) rotate(45)",
    id: "rect3",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 32.53,
    y: 27.26,
    width: 13.44,
    height: 4.03,
    transform: "translate(32.2 -19.18) rotate(45)",
    id: "rect4",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 32.53,
    y: 32.96,
    width: 13.44,
    height: 4.03,
    transform: "translate(36.23 -17.51) rotate(45)",
    id: "rect5",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 23.03,
    y: 35.81,
    width: 13.44,
    height: 4.03,
    transform: "translate(-18.03 32.12) rotate(-45)",
    id: "rect6",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 23.03,
    y: 30.11,
    width: 13.44,
    height: 4.03,
    transform: "translate(-14 30.45) rotate(-45)",
    id: "rect7",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 23.03,
    y: 24.41,
    width: 13.44,
    height: 4.03,
    transform: "translate(-9.97 28.78) rotate(-45)",
    id: "rect8",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 23.03,
    y: 18.71,
    width: 13.44,
    height: 4.03,
    transform: "translate(-5.94 27.11) rotate(-45)",
    id: "rect9",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 23.03,
    y: 13.01,
    width: 13.44,
    height: 4.03,
    transform: "translate(-1.91 25.44) rotate(-45)",
    id: "rect10",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 13.53,
    y: 10.16,
    width: 13.44,
    height: 4.03,
    transform: "translate(14.54 -10.75) rotate(45)",
    id: "rect11",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 13.53,
    y: 15.86,
    width: 13.44,
    height: 4.03,
    transform: "translate(18.57 -9.08) rotate(45)",
    id: "rect12",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 13.53,
    y: 21.56,
    width: 13.44,
    height: 4.03,
    transform: "translate(22.6 -7.41) rotate(45)",
    id: "rect13",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 13.53,
    y: 27.26,
    width: 13.44,
    height: 4.03,
    transform: "translate(26.63 -5.74) rotate(45)",
    id: "rect14",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 13.53,
    y: 32.96,
    width: 13.44,
    height: 4.03,
    transform: "translate(30.66 -4.07) rotate(45)",
    id: "rect15",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 4.03,
    y: 35.81,
    width: 13.44,
    height: 4.03,
    transform: "translate(-23.6 18.68) rotate(-45)",
    id: "rect16",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 4.03,
    y: 30.11,
    width: 13.44,
    height: 4.03,
    transform: "translate(-19.57 17.01) rotate(-45)",
    id: "rect17",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 4.03,
    y: 24.41,
    width: 13.44,
    height: 4.03,
    transform: "translate(-15.54 15.34) rotate(-45)",
    id: "rect18",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 4.03,
    y: 18.71,
    width: 13.44,
    height: 4.03,
    transform: "translate(-11.51 13.67) rotate(-45)",
    id: "rect19",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    fill: "none",
    stroke: "#09253e",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    x: 4.03,
    y: 13.01,
    width: 13.44,
    height: 4.03,
    transform: "translate(-7.48 12) rotate(-45)",
    id: "rect20",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosaPavimenti);
export default __webpack_public_path__ + "static/media/posa_pavimenti.c9d6f06dfa9397a47d585f4900b71a88.svg";
export { ForwardRef as ReactComponent };